import React, { useState } from 'react';
import './Projects.css';

// Modal component for displaying full-size images
const ProjectModal = ({ project, onClose }) => {
  if (!project) return null;
  
  return (
    <div className="project-modal-overlay" onClick={onClose}>
      <div className="project-modal-content">
        <button className="modal-close-btn" onClick={onClose}>×</button>
        <div className="modal-image-container">
          <img src={project.image} alt={project.title} />
          <div className="modal-project-title">
            <h2>{project.title}</h2>
            <p>{project.location}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Projects = ({ setCurrentPage, setActiveSection }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);

  const projectCategories = [
    { id: 'all', name: 'ALL PROJECTS' },
    { id: 'unfinished', name: 'UNFINISHED PROJECTS' },
    { id: 'finished', name: 'FINISHED PROJECTS' }
  ];

  const projects = [
    {
      id: 1,
      title: "SM Development Corporation",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/SM.jpg",
      location: "Metro Manila"
    },
    {
      id: 2,
      title: "Lotte Gulermak EEI Joint Venture - LRT Project",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/LRT.jpg",
      location: "Metro Manila"
    },
    {
      id: 3,
      title: "MICARA Estates",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/MICARA.jpg",
      location: "Metro Manila"
    },
    {
      id: 4,
      title: "Skyway Project",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/SKYWAY.jpg",
      location: "Metro Manila"
    },
    {
      id: 5,
      title: "CALAX Project",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/CALAX.jpg",
      location: "Laguna"
    },
    {
      id: 6,
      title: "ZADIA Residential Development",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/ZADIA.jpg",
      location: "Metro Manila"
    },
    {
      id: 7,
      title: "CALM Development",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/CALM.jpg",
      location: "Metro Manila"
    },
    {
      id: 8,
      title: "Temple Project",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/TEMPLE.jpg",
      location: "Metro Manila"
    },
    {
      id: 9,
      title: "S&R Calamba",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/S&R CALAMBA.jpg",
      location: "Calamba, Laguna"
    },
    {
      id: 10,
      title: "Ateneo de Manila University",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/ATENEO.jpg",
      location: "Quezon City"
    },
    {
      id: 11,
      title: "Joy Residence",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/JOY RESIDENCE.jpg",
      location: "Metro Manila"
    },
    {
      id: 12,
      title: "FPDI Development",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/FPDI.jpg",
      location: "Metro Manila"
    },
    {
      id: 13,
      title: "Baugues Project",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/BAUGUES.jpg",
      location: "Metro Manila"
    },
    {
      id: 14,
      title: "North and South Railway Project",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/NORTH AND SOUTH RAILWAY.jpg",
      location: "Multiple Locations"
    },
    {
      id: 15,
      title: "Bayshore Residential Resort",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/BAYSHORE.jpg",
      location: "Pasay City"
    },
    {
      id: 16,
      title: "Congressional Project",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/CONGRESSIONAL.jpg",
      location: "Metro Manila"
    },
    {
      id: 17,
      title: "McDonald's Pangasinan",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/MC DONALD PANGASINAN.jpg",
      location: "Pangasinan"
    },
    {
      id: 18,
      title: "Agapeya Development",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/AGAPEYA.jpg",
      location: "Metro Manila"
    },
    {
      id: 19,
      title: "Tower Development",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/TOWER.jpg",
      location: "Metro Manila"
    },
    {
      id: 20,
      title: "La Salle Project",
      category: "finished",
      image: "/Testing/GEOMATIXS PROJECTS/LA SALLE.jpg",
      location: "Metro Manila"
    },
    {
      id: 21,
      title: "Rio Tuba Project",
      category: "unfinished",
      image: "/Testing/GEOMATIXS PROJECTS/RIOTUBA.jpg",
      location: "Palawan"
    }
  ];

  const filteredProjects = activeCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeCategory);

  return (
    <div className="projects-page">
      {/* Navigation Bar */}
      <div className="icon-navbar visible">
        <div className="button-container">
          {/* GGC Logo */}
          <div className="nav-logo">
            <img 
              src={`${process.env.PUBLIC_URL}/geologo.png`} 
              alt="Geomatixs Group Corporation" 
              className="nav-logo-img"
            />
          </div>
          
          <button 
            className="button"
            onClick={() => {
              setCurrentPage('home');
              setActiveSection('home');
            }}
            title="Home"
          >
            Home
          </button>
          
          <button 
            className="button"
            onClick={() => {
              setCurrentPage('services');
              setActiveSection('services');
            }}
            title="Services"
          >
            Services
          </button>

          <button 
            className="button active"
            onClick={() => {
              setCurrentPage('projects');
              setActiveSection('projects');
            }}
            title="Projects"
          >
            Projects
          </button>

                    <button
            className="button"
            onClick={(e) => {
              e.preventDefault();
              // Go to home page first
              setCurrentPage('home');
              setActiveSection('branches');
              
              // Use a more reliable method to wait for the element
              const waitForBranchesSection = () => {
                const branchesSection = document.getElementById('branches');
                if (branchesSection) {
                  branchesSection.scrollIntoView({ behavior: 'smooth' });
                } else {
                  // If not found, try again in 50ms
                  setTimeout(waitForBranchesSection, 50);
                }
              };
              
              // Start waiting for the section after a short delay
              setTimeout(waitForBranchesSection, 150);
            }}
            title="Branches"
          >
            Branches
          </button>

          <button 
            className="button"
            onClick={(e) => {
              e.preventDefault();
              // Go to testing page first
              setCurrentPage('testing');
              setActiveSection('testing');
              
              // Use a more reliable method to wait for the element
              const waitForTestingSection = () => {
                const testingSection = document.getElementById('testing');
                if (testingSection) {
                  testingSection.scrollIntoView({ behavior: 'smooth' });
                } else {
                  // If not found, try again in 50ms
                  setTimeout(waitForTestingSection, 50);
                }
              };
              
              // Start waiting for the section after a short delay
              setTimeout(waitForTestingSection, 150);
            }}
            title="Testing"
          >
            Testing
          </button>
        </div>

        {/* Mobile Top Navigation */}
        <div className="mobile-nav-container">
          <div className="mobile-logo">GEOMATIXS</div>
          <button 
            className="mobile-menu-toggle"
            onClick={() => {
              const menu = document.querySelector('.mobile-menu');
              if (menu) {
                menu.classList.toggle('active');
              }
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
            </svg>
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        <div className="mobile-menu">
          <button 
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('home');
              setActiveSection('home');
              window.scrollTo({ top: 0, behavior: 'smooth' });
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
            <span>Home</span>
          </button>
          <button 
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('services');
              setActiveSection('services');
              window.scrollTo(0, 0);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <span>Services</span>
          </button>
          <button 
            className="mobile-menu-item active"
            onClick={() => {
              setCurrentPage('projects');
              setActiveSection('projects');
              window.scrollTo(0, 0);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
            <span>Projects</span>
          </button>
          <button 
            className="mobile-menu-item"
            onClick={(e) => {
              e.preventDefault();
              if (setCurrentPage !== 'home') {
                setCurrentPage('home');
                setTimeout(() => {
                  setActiveSection('branches');
                  const branchesSection = document.getElementById('branches');
                  if (branchesSection) {
                    branchesSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              } else {
                setActiveSection('branches');
                const branchesSection = document.getElementById('branches');
                if (branchesSection) {
                  branchesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
            <span>Branches</span>
          </button>
          <button 
            className="mobile-menu-item"
            onClick={() => {
              setCurrentPage('testing');
              setActiveSection('testing');
              window.scrollTo(0, 0);
              document.querySelector('.mobile-menu')?.classList.remove('active');
            }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-9H19V1h-2v1H7V1H5v1H4.5C3.67 2 3 2.67 3 3.5v15C3 19.33 3.67 20 4.5 20h15c.83 0 1.5-.67 1.5-1.5v-15C21 2.67 20.33 2 19.5 2z"/>
            </svg>
            <span>Testing</span>
          </button>
        </div>
      </div>

      <div className="container">
        <div className="projects-header">
          <h1>Our Project Gallery</h1>
          <p>Showcasing our expertise across various construction and development projects</p>
        </div>
        
        <div className="project-categories">
          <div className="category-tabs">
            {projectCategories.map(category => (
              <button
                key={category.id}
                className={`category-tab ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
        
        <div className="projects-grid">
          {filteredProjects.map(project => (
            <div key={project.id} className="project-card" onClick={() => setSelectedProject(project)}>
              <div className="project-image">
                <img 
                  src={project.image} 
                  alt={project.title}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'block';
                  }}
                />
                <div className="image-fallback" style={{display: 'none'}}>
                  <span>🏗️</span>
                </div>
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <div className="project-meta">
                  <span className="location">📍 {project.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ProjectModal 
          project={selectedProject} 
          onClose={() => setSelectedProject(null)} 
        />
      </div>
    </div>
  );
};

export default Projects;
